import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { H1, HEADING_TYPES } from '../Heading/index'

function ConstructionMessage (props) {
  const { staticText } = props

  return (
    <div className="construction-message">
      <H1 as={HEADING_TYPES.H3} className="construction-message__title">
        {staticText.get('title')}
      </H1>
      <p>{staticText.get('message')}</p>
    </div>
  )
}

ConstructionMessage.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectRedux(
    (state) => ({
      staticText: state.staticText.getIn(['data', 'constructionMessage', 'data']),
    }),
  ),
)(ConstructionMessage)
